import React from 'react';
import PropTypes from 'prop-types';
import moment from 'utils/cops-moment';
import { Row, Col } from 'antd';
import { SubTitle, FormItem, FormText, DatePicker } from 'ui';
import { FormattedDate, injectIntl } from 'react-intl';

const Dates = ({
  data: {
    validFromDate,
    startUpDate,
    acquisitionDate,
  },
  isEditable,
  form,
  disabled,
  intl,
}) => {
  const { getFieldDecorator } = form;

  const toDate = datestring => moment(datestring).isValid() ? moment(datestring) : null;

  const validFromDateValidator = getFieldDecorator('validFromDate', {
    initialValue: toDate(validFromDate),
  });

  const startUpDateValidator = getFieldDecorator('startUpDate', {
    initialValue: toDate(startUpDate),
  });

  const acquisitionDateValidator = getFieldDecorator('acquisitionDate', {
    initialValue: toDate(acquisitionDate),
  });

  return (
    <>
      <SubTitle>{intl.formatMessage({ id: 'common.titles.DATES' })}</SubTitle>
      <Row type='flex' gutter={16}>
        <Col md={8} sm={24} xs={24} data-test-id='dates.creation'>
          <FormItem label={intl.formatMessage({ id: 'dates.CREATION_DATE' })}>
            {isEditable ?
              validFromDateValidator(<DatePicker disabled={disabled} />)
              :
              <FormText>{validFromDate && <FormattedDate value={validFromDate} />}</FormText>
            }
          </FormItem>
        </Col>
        <Col md={8} sm={24} xs={24} data-test-id='dates.startup'>
          <FormItem label={intl.formatMessage({ id: 'dates.INSTALLATION_DATE' })}>
            {isEditable ?
              startUpDateValidator(<DatePicker disabled={disabled} />)
              :
              <FormText>{startUpDate && <FormattedDate value={startUpDate} />}</FormText>
            }
          </FormItem>
        </Col>
        <Col md={8} sm={24} xs={24} data-test-id='dates.acquisition'>
          <FormItem label={intl.formatMessage({ id: 'dates.ACQUISITION_DATE' })}>
            {isEditable ?
              acquisitionDateValidator(<DatePicker disabled={disabled} />)
              :
              <FormText>{acquisitionDate && <FormattedDate value={acquisitionDate} />}</FormText>
            }
          </FormItem>
        </Col>
      </Row>
    </>
  );
};

Dates.propTypes = {
  data: PropTypes.object,
  isEditable: PropTypes.bool,
  form: PropTypes.object,
  disabled: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(Dates);
